// src/notifications/handlers.ts
import { TNotification } from "@/types/types";
import { setQueryParam } from "@/utils/setQueryParam";

export function notificationHandlers(n: TNotification) {
  switch (n.template_id) {
    case "creator-project-request-001": {
      // ✅ Prefer explicit value if backend sends it
      let projectId = (n.data as any)?.project_id as string | undefined;

      // fallback: parse from link
      if (!projectId) {
        const link = (n.data as any)?.link as string | undefined;
        if (link) {
          try {
            const u = new URL(link, window.location.origin);
            projectId = u.searchParams.get("project_id") ?? undefined;
          } catch {
            // ignore invalid URLs
          }
        }
      }

      if (!projectId) return;

      // ✅ same route, just add query param
      setQueryParam("project_id", projectId, { replace: false });
      return;
    }

    default:
      return;
  }
}
